import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  inject,
  Renderer2,
  signal,
  viewChild,
  WritableSignal
} from '@angular/core';
import { BaseComponent } from '../../abstract-components/base.component';
import { RouterModule } from '@angular/router';
import { combineLatest, map } from 'rxjs';
import { CommonModule } from '@angular/common';
import { BreakpointsService } from '../../services/breakpoints.service';
import { ContentWrapperComponent } from '../../components/layouts/content-wrapper/content-wrapper.component';

@Component({
  selector: 'layout',
  imports: [CommonModule, RouterModule, ContentWrapperComponent],
  providers: [BreakpointsService],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayoutComponent extends BaseComponent implements AfterViewInit {
  protected _renderer = inject(Renderer2);
  protected _breakpointsService = inject(BreakpointsService);

  isLargeScreen$ = combineLatest([
    this._breakpointsService.isLargeScreen$,
    this._breakpointsService.isXLargeScreen$
  ]).pipe(
    map(([isLargeScreen, isXLargeScreen]) => isLargeScreen || isXLargeScreen)
  );

  isTinyScreen$ = this._breakpointsService.isTinyScreen$;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  layout = viewChild('layout') as any;

  protected sideContainerHeightStyle: WritableSignal<Record<string, string>> =
    signal({});

  ngAfterViewInit(): void {
    if (this._isPlatformBrowser) {
      this._getSideContentHeight();
      this._listenToWindowResize();
    }
  }

  private _listenToWindowResize(): void {
    this._renderer.listen('window', 'resize', () => {
      this._getSideContentHeight();
    });
  }

  private _getSideContentHeight(): void {
    const layout = this.layout()?.nativeElement as HTMLElement | null;
    const header = layout?.querySelector('.layout-header-wrapper');
    const footer = layout?.querySelector('.layout-footer-wrapper');

    const headerHeight = header ? header.getBoundingClientRect().height : 0;
    const footerHeight = footer ? footer.getBoundingClientRect().height : 0;
    this.sideContainerHeightStyle.set({
      height: `calc(100vh - ${headerHeight}px - ${footerHeight}px)`,
      top: `${headerHeight}px`
    });
  }
}
